module.exports = " <div class=search_bar _v-2c2110e7=\"\"> <input class=keyword type=text v-model=keyword placeholder=在这里输入关键字 _v-2c2110e7=\"\"> <input class=submit type=submit value=查找 _v-2c2110e7=\"\"> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-2c2110e7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/discover/SearchBar.vue
 ** module id = 340
 ** module chunks = 2
 **/